// extracted by mini-css-extract-plugin
module.exports = {"appStyle":"_1oIAcRMpQRdok7UGubnVm_"};